export const GROHE_POST_MESSAGES_ACTIONS = {
  exit: "EXIT",
  save: "SAVE",
  addToCart: "ADDTOCART",
  signIn: "SIGNIN",
  openMiniCart: "OPENMINICART",
}

export const GROHE_ON_OPEN_ACTION = {
  shareFacebook: "facebook",
  shareTwitter: "twitter",
  sharePinterest: "pinterest",
  saveQuote: "saveQuote",
}
